import { operatorClient } from 'domain/HttpClients';

export const fetch = (filters) => operatorClient
  .Get('/api/shippers')
  .withParams(filters)
  .send();

export const fetchProfiles = (id) => operatorClient
  .Get('/api/profiles')
  .withParams({ pid: id, did: SYSTEM_DOMAIN })
  .send();
